import GetOrganisationByExternalIdAsyncRequestModelBase from '../_generated/modelBases/get-organisation-by-external-id-async-request-model-base';

export default class GetOrganisationByExternalIdAsyncRequestModel extends GetOrganisationByExternalIdAsyncRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
